import { View, StyleSheet, Text, Image } from "@react-pdf/renderer";
import React from "react";
import { Invoice } from "../../../generated/graphql";

const InvoiceSignature: React.FC<{ invoice: Invoice }> = ({ invoice }) => {
  return (
    <>
      <View style={styles.container}>
        <View style={[styles.col]}>
          <View
            style={[
              styles.signatureContainer,
              { minWidth: 120, marginBottom: 11 },
            ]}
          >
            <Text style={[styles.signature]}>
              {invoice?.customerSignatureName}
            </Text>
          </View>
        </View>
        <View style={[styles.col, { position: "relative" }]}>
          <Image
            src={invoice?.signatureBackground?.imageUrl}
            style={styles.signatureBackgroundImage}
          />
          <Image
            src={invoice?.signature?.imageUrl}
            style={styles.signatureImage}
          />
          <View style={styles.signatureContainer}>
            <Text style={styles.signature}>{invoice?.signature?.name}</Text>
          </View>
          <Text style={styles.company}>Gesano Tour & Travel Agency</Text>
        </View>
      </View>

      <Text style={styles.textThanks}>
        Thank you for choosing Gesano Travel
      </Text>
    </>
  );
};

// Create styles
const styles = StyleSheet.create({
  container: {
    marginBottom: 6,
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    fontFamily: "Poppins",
    fontSize: 8,
    minHeight: 120,
  },
  col: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  signatureContainer: {
    borderBottom: "1px solid #192855",
    paddingLeft: 5,
    paddingRight: 5,
    minWidth: 80,
  },
  signature: {
    alignSelf: "center",
  },
  company: { fontWeight: 600, color: "#002a8f" },
  signatureBackgroundImage: {
    width: "auto",
    height: 80,
    top: "50%",
    transform: "translateY(-30%)",
    position: "absolute",
  },
  signatureImage: {
    width: 100,
    height: "auto",
    marginBottom: 1,
  },
  textThanks: {
    textAlign: "center",
    fontWeight: 600,
    fontSize: 8,
    marginTop: 10,
    fontFamily: "Poppins",
  },
});

export default InvoiceSignature;
